import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { setSection } from "../../../redux/ducks/Section";
import { initState } from "../../../redux/ducks/RiskAnalysis";
import { setLoading } from "../../../redux/ducks/Loading";
import { initRefresh, setProject } from "../../../redux/ducks/ProjectManagement";
import { resetBillingManagement } from "../../../redux/ducks/BillingPlanManagement";
import { Tabs } from "antd";
import ProjectForm from "./ProjectsManagementTabs/projectForm/ProjectForm";
import ProjectTeam from "./ProjectsManagementTabs/team/ProjectTeam";
import Planning from "./ProjectsManagementTabs/planning/Planning";
import IncomeStatement from "./ProjectsManagementTabs/incomeStatement/IncomeStatement";
import Dashboard from "./ProjectsManagementTabs/dashboard/Dashboard";
import RiskAnalysis from "./ProjectsManagementTabs/RiskAnalysis/RiskAnalysis";
import RiskAnalysisDetail from "./ProjectsManagementTabs/RiskAnalysis/RiskAnalysisDetail";
import { checkRoles, showError } from "../../../utils/utilities";
import { projectsManagementTabs } from "../../../utils/properties";
import { get, indexOf } from "lodash";
import Project from "../../../services/api/Project";

const ProjectsManagementDetails = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const params = useParams();
  const userInfo = useSelector((state) => get(state.userInfoDuck, "userInfo", {}));
  const riskEdit = useSelector((state) => get(state.RiskAnalysisDuck, "edit", false));
  const mappingKey = {
    ProjectForm: <ProjectForm />,
    Team: <ProjectTeam />,
    Planning: <Planning />,
    RiskAnalysis: riskEdit ? <RiskAnalysisDetail /> : <RiskAnalysis />,
    IncomeStatement: <IncomeStatement />,
    Dashboard: <Dashboard />,
  };

  useEffect(() => {
    if (indexOf([null, undefined, ""], location.state) !== -1) {
      navigate("/projects-management");
    } else {
      dispatch(
        setSection({
          section: {
            title:
              `${params.id}` +
              (indexOf([null, undefined, ""], location.state.supplierName) === -1
                ? `| ${location.state.supplierName}`
                : ""),
          },
        })
      );
      getData();
    }
  }, []);

  const getData = async () => {
    dispatch(setLoading(true));
    const infoProject = await Project.getInfoProject(params.id);
    if (!infoProject.error) {
      dispatch(setProject(get(infoProject, "data", {})));
    } else {
      showError(get(infoProject, "error.messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };

  const resetAllDataOnChangeTab = () => {
    dispatch(resetBillingManagement());
    dispatch(initState());
    dispatch(initRefresh());
  };
  const projectsManagementTabsFiltered = [];
  Object.keys(projectsManagementTabs).forEach((p) => {
    if (checkRoles(userInfo.roles, projectsManagementTabs[p].view)) {
      projectsManagementTabsFiltered.push({
        label: t(`projectsManagement.detail.${p}`),
        key: p,
        children: mappingKey[projectsManagementTabs[p].component],
      });
    }
  });
  return (
    <Tabs
      className="PFtabs"
      defaultActiveKey={0}
      onChange={() => resetAllDataOnChangeTab()}
      items={projectsManagementTabsFiltered}
    />
  );
};

export default ProjectsManagementDetails;
